import React, { useState } from 'react';
import '../Styles/Hero.css';

const Hero = () => {
  const [email, setEmail] = useState('');

  const handleInputChange = (event) => {
    setEmail(event.target.value);
  };

  const isEmailValid = email.trim() !== '';

  return (
    <div className="hero-container">
      <div className="club-info">
        <h1 className="hero-header">A community where students can collaborate</h1>
        <p className="hero-description">
          The Computer Science Undergraduate Society is the organization that represents all computer science students at Western University in London, Ontario. CSUS is run by students and for students. Join our mailing list to keep up to date on our events and opportunities.
        </p>
        {/* <form className="email-form">
          <input type="email" id="email" className="email-input" placeholder="Enter your email..." value={email} onChange={handleInputChange}></input>
          <button type="submit" disabled={!isEmailValid}>Join Mailing List</button>
        </form> */}
        <a href="https://forms.gle/yXFvUo57D2N4jTFy5">
          <button className="join-mailing-list-btn">
            JOIN THE MAILING LIST
          </button>
        </a>
      </div>
    </div>
  );
};

export default Hero;
